import utils from 'services/utils';

const menuItems = state => state.menu.items;
const sidebarOpened = state => state.app.sidebar.opened;
const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation;
const config = state => state.app.config;
const palette = state => state.app.config.palette;
const isLoading = state => state.app.isLoading;
const initialized = state => state.app.initialized;
const breadcrumbs = state => {
  return (keyword) => utils.findInNestedByName(state.menu.items, keyword);
};
const api = state => state.app.config.api;
const profile = state => state.app.profile;
const profileId = state => state.app.profile && state.app.profile._id;
const user = state => state.app.user;
const userId = state => state.app.user && state.app.user._id;
const role = state => state.app.profile && state.app.profile.role;
const isAdmin = (state, getters) => getters.role === 'admin';

export {
  menuItems,
  toggleWithoutAnimation,
  sidebarOpened,
  config,
  palette,
  isLoading,
  initialized,
  breadcrumbs,
  api,
  role,
  isAdmin,
  user,
  userId,
  profile,
  profileId,
};



// WEBPACK FOOTER //
// ./src/store/getters.js